/* eslint-disable */

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

// Keyframes และ Styled Components (เหมือนเดิม)
const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: 'Nunito', sans-serif;
  padding: 20px;
  box-sizing: border-box;
`;

const ErrorContainer = styled.div`
  background-color: #ffffff;
  padding: 40px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 600px;
  width: 100%;
  border: 1px solid #e0e0e0;
`;

const Emoji = styled.div`
  font-size: 80px;
  animation: ${floatAnimation} 3s ease-in-out infinite;
  margin-bottom: 20px;
`;

const ErrorCode = styled.h1`
  font-size: 72px;
  font-weight: 900;
  margin: 0;
  color: #343a40;
  background: linear-gradient(45deg, #007bff, #6f42c1);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const BigText = styled.h2`
  font-size: 28px;
  font-weight: 700;
  margin: 10px 0;
  color: #495057;
`;

const SmallText = styled.p`
  font-size: 16px;
  color: #6c757d;
  margin: 20px 0 30px;
  line-height: 1.6;
`;

// 1. ปรับปรุงโครงสร้าง errorMessages
const errorMessages = {
  // สำหรับ code 401 เราจะสร้าง object ที่มีรายละเอียดซ้อนกัน
  401: {
    // ข้อความเริ่มต้นสำหรับ 401 ทั่วไป (ถ้า detail ไม่ตรงกับเงื่อนไข)
    default: {
      emoji: '⚠️',
      // code: '401',
      bigText: 'Unauthorized',
      smallText: 'You are not authorized to access this resource.',
    },
    // เงื่อนไขเฉพาะตามค่าของ 'detail'
    details: {
      'Token expired': {
        emoji: '⏳',
        bigText: 'Session Expired',
        smallText: 'Your session has expired. Please log in again to continue.',
      },
      'jwt must have': {
        emoji: '🚫',
        bigText: 'Invalid Access Token',
        smallText: 'The access token provided is invalid or has been revoked.',
      },
      // สามารถเพิ่มเงื่อนไขอื่นๆ สำหรับ detail ได้ที่นี่
    },
  },
  404: {
    emoji: '🤔',
    code: '404',
    bigText: 'Oops! Page Not Found',
    smallText: 'The page you are looking for does not exist on this server.',
  },
  500: {
    emoji: '🤯',
    code: '500',
    bigText: 'Oops! Internal Server Error',
    smallText:
      'Sorry, we encountered a technical issue. Please try again later.',
  },
  // Default case สำหรับ code ที่ไม่รู้จัก
  default: {
    emoji: '🤔',
    code: '404',
    bigText: 'Oops! Something Went Wrong',
    smallText: 'An unexpected error occurred. Please try again later.',
  },
};

function HttpStatus() {
  const [errorInfo, setErrorInfo] = useState(errorMessages.default);
  const location = useLocation();

  // 2. ปรับปรุง Logic ใน useEffect
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    const detail = query.get('detail');

    // หาข้อมูล error จาก code ที่ได้รับมา
    const codeConfig = errorMessages[code];

    if (codeConfig) {
      // ตรวจสอบว่ามี detail และมีเงื่อนไขเฉพาะสำหรับ detail นั้นหรือไม่
      if (detail && codeConfig.details && codeConfig.details[detail]) {
        // ถ้าเจอเงื่อนไขเฉพาะ ให้ใช้ข้อมูลจาก detail
        const specificDetailInfo = codeConfig.details[detail];
        setErrorInfo({
          ...specificDetailInfo,
          code: code, // ดึง code มาใช้แสดงผล
          emoji: specificDetailInfo.emoji || codeConfig.default.emoji, // ใช้ emoji เฉพาะ หรือ emoji default ของ code นั้น
        });
      } else if (codeConfig.default) {
        // ถ้าไม่มี detail ที่ตรง หรือไม่มี detail ส่งมา แต่มี default สำหรับ code นั้น
        setErrorInfo(codeConfig.default);
      } else {
        // สำหรับ error code ที่ไม่มีโครงสร้างซ้อน (เช่น 404, 500)
        setErrorInfo(codeConfig);
      }
    } else {
      // ถ้าไม่เจอ code ที่กำหนดไว้เลย ให้ใช้ default หลัก
      setErrorInfo(errorMessages.default);
    }
  }, [location]);

  return (
    <PageWrapper>
      <ErrorContainer>
        <Emoji>{errorInfo.emoji}</Emoji>

        {/*
          *** จุดที่แก้ไข ***
          เพิ่มเงื่อนไขตรงนี้: ถ้า errorInfo.code ไม่ใช่ '401' ให้แสดง <ErrorCode>
        */}
        {errorInfo.code !== '401' && <ErrorCode>{errorInfo.code}</ErrorCode>}

        <BigText>{errorInfo.bigText}</BigText>
        <SmallText>{errorInfo.smallText}</SmallText>
        {/* <HomeButton to="/">Go Back to Home</HomeButton> */}
      </ErrorContainer>
    </PageWrapper>
  );
}

export default HttpStatus;
